'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reveal = require('react-foundation-components/lib/global/reveal');

var _reactTabs = require('react-tabs');

var _translateUtils = require('../translateUtils');

var _adblock = require('../../images/adblock.jpg');

var _adblock2 = _interopRequireDefault(_adblock);

var _adblockplus = require('../../images/adblockplus.jpg');

var _adblockplus2 = _interopRequireDefault(_adblockplus);

var _ublock = require('../../images/ublock.jpg');

var _ublock2 = _interopRequireDefault(_ublock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdblockDisableInstructionsView = function (_Component) {
    _inherits(AdblockDisableInstructionsView, _Component);

    function AdblockDisableInstructionsView() {
        _classCallCheck(this, AdblockDisableInstructionsView);

        return _possibleConstructorReturn(this, (AdblockDisableInstructionsView.__proto__ || Object.getPrototypeOf(AdblockDisableInstructionsView)).apply(this, arguments));
    }

    _createClass(AdblockDisableInstructionsView, [{
        key: 'render',
        value: function render() {
            var t = this.props.t;

            return _react2.default.createElement(
                'div',
                { className: 'main_container row expanded undefined off-canvas-wrapper' },
                _react2.default.createElement(
                    'div',
                    { className: 'off-canvas-wrapper-inner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'eft_col off-canvas position-left reveal-for-large', style: { position: 'absolute' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'left_col scroll-view' },
                            _react2.default.createElement(
                                'div',
                                { className: 'navbar nav_title' },
                                _react2.default.createElement(
                                    'a',
                                    { className: 'site_title', href: '/' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'timeline-wrapper' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'timeline__menu timeline__logo' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'timeline__bg' },
                                                _react2.default.createElement('div', { className: 'timeline__masker header-top' }),
                                                _react2.default.createElement('div', { className: 'timeline__masker header-left' }),
                                                _react2.default.createElement('div', { className: 'timeline__masker subheader-bottom' }),
                                                _react2.default.createElement('div', { className: 'timeline__masker content-middle second' })
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement('div', { className: 'clearfix' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'main_menu_side hidden-print main_menu' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'menu_section' },
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'side-menu menu vertical', style: { display: 'flex' } },
                                        _react2.default.createElement(
                                            'li',
                                            { className: '' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'timeline-wrapper' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'timeline__menu' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'timeline__bg' },
                                                        _react2.default.createElement('div', { className: 'timeline__masker header-top' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker header-left' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker subheader-bottom' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker content-middle second' })
                                                    )
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: '' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'timeline-wrapper' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'timeline__menu' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'timeline__bg' },
                                                        _react2.default.createElement('div', { className: 'timeline__masker header-top' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker header-left' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker subheader-bottom' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker content-middle' })
                                                    )
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: '' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'timeline-wrapper' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'timeline__menu' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'timeline__bg' },
                                                        _react2.default.createElement('div', { className: 'timeline__masker header-top' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker header-left' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker subheader-bottom' }),
                                                        _react2.default.createElement('div', { className: 'timeline__masker content-middle third' })
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'off-canvas-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'top_nav title-bar' },
                            _react2.default.createElement(
                                'div',
                                { className: 'title-bar-left' },
                                _react2.default.createElement('div', { className: 'nav_menu clearfix' })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('div', { className: 'right_col' })
                        ),
                        _react2.default.createElement(
                            'footer',
                            { className: 'footer' },
                            _react2.default.createElement(
                                'div',
                                { className: 'footer__item column' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'footer__info row expanded' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'small-12 columns' },
                                        _react2.default.createElement(
                                            'p',
                                            null,
                                            'Copyright \xA9 United Traders. 2009-2017'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement('div', { className: 'notifications-wrapper' }),
                        _react2.default.createElement('div', { className: 'js-off-canvas-exit' })
                    )
                ),
                _react2.default.createElement(
                    _reveal.Reveal,
                    { show: true, revealClassName: 'reveal__ad' },
                    _react2.default.createElement(
                        'h1',
                        { className: 'font-style_bold text-center margin__standard_bottom' },
                        t('Please disable adblocker and reload the page')
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'margin__standard_bottom' },
                        t('System needs adblockers disabled to function properly')
                    ),
                    _react2.default.createElement(
                        _reactTabs.Tabs,
                        null,
                        _react2.default.createElement(
                            _reactTabs.TabList,
                            null,
                            _react2.default.createElement(
                                _reactTabs.Tab,
                                null,
                                'Adblock'
                            ),
                            _react2.default.createElement(
                                _reactTabs.Tab,
                                null,
                                'AdBlock Plus'
                            ),
                            _react2.default.createElement(
                                _reactTabs.Tab,
                                null,
                                'uBlock Origin'
                            )
                        ),
                        _react2.default.createElement(
                            _reactTabs.TabPanel,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'ad__img' },
                                _react2.default.createElement('img', { src: _adblock2.default, alt: 'AdBlock' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ad__desc' },
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '1. ',
                                        t('Press the icon next to the address bar'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '2. ',
                                        t('Choose "Don\'t run on pages on this domain"'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '3. ',
                                        t('Accept your choice by pressing "Exclude"'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '4. ',
                                        t('Icon becomes green when disabling is complete'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ad__reload' },
                                            _react2.default.createElement(
                                                'a',
                                                { href: '#', className: 'button button__default', onClick: this._reloadPage },
                                                t('Reload')
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactTabs.TabPanel,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'ad__img' },
                                _react2.default.createElement('img', { src: _adblockplus2.default, alt: 'AdBlock Plus' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ad__desc' },
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '1. ',
                                        t('Press the icon next to the address bar'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '2. ',
                                        t('Choose "Enabled on this site"'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '3. ',
                                        t('Item changes to "Disabled", icon becomes gray'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ad__reload' },
                                            _react2.default.createElement(
                                                'a',
                                                { href: '#', className: 'button button__default', onClick: this._reloadPage },
                                                t('Reload')
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _reactTabs.TabPanel,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'ad__img' },
                                _react2.default.createElement('img', { src: _ublock2.default, alt: 'uBlock Origin' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'ad__desc' },
                                _react2.default.createElement(
                                    'ul',
                                    null,
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '1. ',
                                        t('Press the icon next to the address bar'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '2. ',
                                        t('Press disable button'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        '3. ',
                                        t('Icon becomes gray when you disable the blocker'),
                                        '.'
                                    ),
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'ad__reload' },
                                            _react2.default.createElement(
                                                'a',
                                                { href: '#', className: 'button button__default', onClick: this._reloadPage },
                                                t('Reload')
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }, {
        key: '_reloadPage',
        value: function _reloadPage(e) {
            e.preventDefault();
            location.reload(); // eslint-disable-line
        }
    }]);

    return AdblockDisableInstructionsView;
}(_react.Component);

AdblockDisableInstructionsView.propTypes = {
    t: _propTypes2.default.func.isRequired
};
exports.default = (0, _translateUtils.translate)(AdblockDisableInstructionsView);


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/adblock/AdblockDisableInstructionsView.js
// module id = 1310
// module chunks = 118